import { Component, DestroyRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NotificationService } from "@app/core";
import { IBusinessPartner } from "@app/shared/data-access/src/lib/resource-management/models/business-partners";
import { catchError, of } from "rxjs";
import { ResourceManagementApiService } from "@app/shared/data-access/src/lib/resource-management/services/resource-management-api.service";
import { ApiErrorFieldEnum } from "@models/http/http-options";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "business-partner-toggle",
  templateUrl: "./business-partner-toggle.component.html",
  standalone: false,
})
export class BusinessPartnerToggleComponent {
  @Input() item: IBusinessPartner;

  private readonly referenceBooksApiService = inject(
    ResourceManagementApiService,
  );
  private readonly destrorRef = inject(DestroyRef);
  private readonly notificationService = inject(NotificationService);

  toggle(): void {
    const previousState = this.item.isActive;
    this.item.isActive = !this.item.isActive;

    this.referenceBooksApiService[previousState ? "deactivate" : "activate"](
      this.item.id,
    )
      .pipe(
        takeUntilDestroyed(this.destrorRef),
        catchError((err: HttpErrorResponse) => {
          this.item.isActive = previousState;
          this.notificationService.findAndShowErrors(
            err,
            ApiErrorFieldEnum.Code,
          );
          return of(null);
        }),
      )
      .subscribe();
  }
}
